export default {
  BUTTON_PRIMARY_CLASS: 'button',
  BUTTON_SECONDARY_CLASS: 'button button--secondary',
  SEARCH_BOX_BUTTON_CLASS: 'button',
  FACET_DIALOG_BUTTON_CLASS: 'button--grey button--small',
  FACET_BUTTON_CLASS: 'button--clear',

  SEARCH_BOX_INPUT_CLASS: 'form-input',
  SEARCH_BOX_SECTION_TITLE: "{{sectionTitle}}{this.totalHits > 1 ? ` (${this.totalHits})` : ''}",
  BROWSE_ALL: 'View All Products',

  SELECT_CLASS: 'cm_form-select form-select form-select--small',
  SORT_BY: 'Sort by',

  START_OVER: '<rt-virtual template="icons/times" /> Clear all',
  FILTERS_ICON: '<rt-virtual  template="icons/filter-empty" />',
  FACET_TITLE_ICON: `
    <rt-virtual rt-if="this.isCollapsed" template="icons/plus" />
    <rt-virtual rt-if="!this.isCollapsed" template="icons/minus" />`,
  FACET_DIALOG_TITLE: '<rt-virtual template="icons/filter-empty" /> Filters',
  FACET_DIALOG_VEHICLE_SPECS_TITLE: 'Add optional vehicle info',
  FACET_DIALOG_VEHICLE_SPECS_RESET: 'Reset',
  FACET_DIALOG_DONE: 'Apply Filters',
  FACET_DIALOG_CLEAR: '<rt-virtual template="icons/times" /> Clear All Filters',

  REMOVE_VEHICLE_ICON: '<rt-virtual template="icons/trash" />',

  SELECT_YOUR_VEHICLE: 'Shop by Vehicle',
  SELECT_YOUR_VEHICLE_BLOCK: 'Shop by Vehicle',
  CLEAR_TEXT: '<rt-virtual template="icons/times" /> Clear all',
  DISCARD_VEHICLE: '<rt-virtual template="icons/times" /> Clear all',
  GO_TEXT: 'Search Products',
  CHANGE_VEHICLE: 'Change Vehicle',
  SELECT_TITLE: '- Select {{ title }} -',
  ADD_VEHICLE: 'Add Vehicle',
};
